import { Box } from "@material-ui/core";
import React from "react";

import { LiveCommerceItemCounter } from "./LiveCommerceItemCounter";

import type { ProductData } from "@spwn/types/firebase/firestore";
import type { FC, SVGAttributes } from "react";

export const LiveCommerceDrawer: FC<{
  isDrawerOpen: boolean;
  pseudoCart: (ProductData & { count: number })[];
  decrementGoodsCount: (itemData: ProductData) => void;
  incrementGoodsCount: (itemData: ProductData) => void;
  onClickCloseDrawer: () => void;
}> = ({
  isDrawerOpen,
  pseudoCart,
  decrementGoodsCount,
  incrementGoodsCount,
  onClickCloseDrawer,
}) => {
  const DRAWER_HEIGHT = 360;

  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      height={"0px"}
      padding={"16px"}
      fontSize={"14px"}
      fontWeight={"700"}
      bgcolor={"#F0F0F0"}
      borderTop={"1px solid #A3A3A3"}
      borderBottom={"1px solid #A3A3A3"}
      visibility={"hidden"}
      style={{
        opacity: 0,
        transition: "all 0.3s ease-in-out",
        ...(isDrawerOpen && {
          height: `${DRAWER_HEIGHT}px`,
          visibility: "visible",
          opacity: 1,
        }),
      }}
    >
      <Box
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
        gridGap={"8px"}
        overflow={"scroll"}
      >
        <Box>カート1</Box>
        <Box
          style={{
            width: "24px",
            height: "auto",
            cursor: "pointer",
            transform: "rotate(0deg)",
          }}
          onClick={onClickCloseDrawer}
        >
          <ArrowIcon />
        </Box>
      </Box>

      <Box
        display={"flex"}
        flex={"1 1 auto"}
        flexDirection={"column"}
        gridGap={"16px"}
        height={""}
        padding={"16px"}
        overflow={"scroll"}
      >
        {pseudoCart.map((item, index) => {
          return (
            <CartItem
              key={index}
              goodsImage={item.thumbnail ?? ""}
              goodsName={item.name}
              goodsPrice={item.price_jpy}
              goodsCount={item.count ?? 0}
              decrementGoodsCount={() => decrementGoodsCount(item)}
              incrementGoodsCount={() => incrementGoodsCount(item)}
            />
          );
        })}
      </Box>
    </Box>
  );
};

export const CartItem: FC<{
  goodsImage: string;
  goodsName: string;
  goodsPrice: number;
  goodsCount: number;
  decrementGoodsCount: () => void;
  incrementGoodsCount: () => void;
}> = ({
  goodsImage,
  goodsName,
  goodsPrice,
  goodsCount,
  decrementGoodsCount,
  incrementGoodsCount,
}) => {
  return (
    <Box display={"grid"} gridTemplateColumns={"80px 1fr"} gridGap={"16px"}>
      <Box>
        <img
          src={goodsImage}
          alt={goodsName}
          style={{
            width: "100%",
            height: "auto",
          }}
        />
      </Box>

      <Box style={{ minWidth: 0 }}>
        <Box
          fontSize={"14px"}
          fontWeight={"700"}
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {goodsName}
        </Box>
        <Box color={"#A3A3A3"} fontSize={"14px"} fontWeight={"500"}>
          ¥{goodsPrice.toLocaleString()}
        </Box>
        <Box marginY={"4px"}>
          <LiveCommerceItemCounter
            count={goodsCount}
            decrementNumber={decrementGoodsCount}
            incrementNumber={incrementGoodsCount}
          />
        </Box>
      </Box>
    </Box>
  );
};

const ArrowIcon: FC<SVGAttributes<SVGElement>> = (props) => {
  return (
    <svg viewBox="0 0 24 24" {...props}>
      <path
        d="M7.41 8.58984L12 13.1698L16.59 8.58984L18 9.99984L12 15.9998L6 9.99984L7.41 8.58984Z"
        fill="black"
      />
    </svg>
  );
};
